import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=32a41d8c&scoped=true"
import script from "@/views/Settings/Colors/Colors.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Colors/Colors.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Colors/colors.scss?vue&type=style&index=0&id=32a41d8c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a41d8c",
  null
  
)

export default component.exports